import { JSX, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './components/Router';
import { version } from 'process';
import './styles/main.scss';
import LogCannon from '@ace-clublabs/log-cannon';
import { TeamValue, WorkloadValue } from '@ace-clublabs/aws-tags';
import { ThemeProvider } from '@ace-clublabs/shared-component-library';
import { AuthenticationProvider } from './components/AuthenticationProvider/AuthenticationProvider';
import { useRemote } from './api/sources';

const App: () => JSX.Element = () => {
  let base_url = (global as any).public_url || '/';

  LogCannon.init('9SCaqyfl4dmanklz9bTzx5MNbhyCNb', {
    team: TeamValue.Membership,
    component: 'replacement-card',
    workload: WorkloadValue.MembershipManagement,
    runtime: 'nodejs',
    runtimeVersion: version,
  } as any);

  useEffect(() => {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });

    return () => {
      window.removeEventListener('pageshow', () => {});
    };
  }, []);

  return (
    <BrowserRouter basename={base_url}>
      <ThemeProvider>
        <div className="container">
          <AuthenticationProvider useStubs={!useRemote}>
            <Router />
          </AuthenticationProvider>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
